import {
  infoFetchEspaciosCurricularesI,
  makeEspacioCurricular,
} from "dtos/espacioCurricular";
import { ENDPOINTS } from "./endpoints";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";

export const getEspaciosCurriculares = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchEspaciosCurricularesI>
  >({
    method: "GET",
    uri: ENDPOINTS.ESPACIOS_CURRICULARES,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  const elementosFormated = response.elementos.map((ctElemento) =>
    makeEspacioCurricular(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const postEspacioCurricular = async ({ params }: FetchCallbackI) => {
  const response = await sendRequest({
    method: "POST",
    uri: ENDPOINTS.ESPACIOS_CURRICULARES,
    // params: servicesUtils.removeNullParamsInFilters(params),
    params,
  });
};

export const putEspacioCurricular = async ({ params }: FetchCallbackI) => {
  const response = await sendRequest({
    method: "PUT",
    uri: ENDPOINTS.ESPACIOS_CURRICULARES,
    // params: servicesUtils.removeNullParamsInFilters(params),
    params,
  });
};

export const deleteEspacioCurricular = async (id: any) => {
  await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.ESPACIOS_CURRICULARES + "/" + id,
  });
};

export const getEspacioCurricularById = async (id: any, params?: any) => {
  const response = await sendRequest<
    infoFetchEspaciosCurricularesI | undefined
  >({
    method: "GET",
    uri: ENDPOINTS.ESPACIOS_CURRICULARES + "/" + id,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return response ? makeEspacioCurricular(response) : undefined;
};

  export const getEspaciosCurricularesByCajaCurricular = async (params: any) => {
    const response = await sendRequest<
      getResponseWithPagination<infoFetchEspaciosCurricularesI>
    >({
      method: "GET",
      uri: ENDPOINTS.ESPACIOS_CURRICULARES + "/by-caja-curricular/" + params.caja_curricular_id,
      params: servicesUtils.removeNullParamsInFilters(params),
    });
    console.log("sresponse", response);

    const elementosFormated = response.elementos.map((ctElemento) =>
      makeEspacioCurricular(ctElemento),
    );
    return {
      ...response,
      elementos: elementosFormated,
    };
  };

export const getEspaciosCurricularesByPlanEstudio = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchEspaciosCurricularesI>
  >({
    method: "GET",
    uri: ENDPOINTS.ESPACIOS_CURRICULARES + "/by-plan-estudio/" + params.plan_estudio_id,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  console.log("sresponse by plan -,: ", response);

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeEspacioCurricular(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
}; 
